<template>
    <div class="back-link">
        <slot />
    </div>
</template>

<script setup>

</script>

<style lang="less" src="./BackLink.less"></style>
